var map = {
	"./blue/icon_check-green.svg": "3a96",
	"./blue/icon_vaccine-green.svg": "1248",
	"./blue/icon_virus-green.svg": "0f10",
	"./close-white.svg": "cb6c",
	"./icon_check-green.svg": "f191",
	"./icon_flight.svg": "3180",
	"./icon_seat.svg": "0a51",
	"./icon_vaccine-green.svg": "c565",
	"./icon_vaccine-grey.svg": "42ba",
	"./icon_vaccine-orange.svg": "1886",
	"./icon_vaccine-red.svg": "582d",
	"./icon_virus-green.svg": "6be6",
	"./icon_virus-grey.svg": "432a",
	"./icon_virus-orange.svg": "8dd6",
	"./icon_virus-red.svg": "b191",
	"./icon_x-green.svg": "fde7",
	"./icon_x-grey.svg": "4dea",
	"./icon_x-orange.svg": "a22f",
	"./icon_x-red.svg": "f56b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0075";